import React, { useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./EsiInsurance.css";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
const EsiInsurance = () => {

  const Navigate = useNavigate();
  const [fileErrors, setFileErrors] = useState({
    uploadFile: '',
  });
  const [esicForm, setEsicForm] = useState({
    transactionStatus: "",
    employerCode: "",
    employerName: "",
    challanPeriod: "",
    challanNumber: "",
    challanCreatedDate: "",
    challanSubmittedDate: "",
    amountPaid: "",
    transactionNumber: "",
    uanFile: ""
  });

  const [loading, setLoading] = useState(false);
  const [showSaveSuccess, setShowSaveSuccess] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [savedResponse, setSaveResponse] = useState("");
  const [isFocused, setIsFocused] = useState({ challanPeriod: false, challanCreatedDate: false, challanSubmittedDate: false });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEsicForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleDateChange = (name, date) => {
    // Store formatted date string for consistency
    const formattedDate = date ? format(date, "yyyy-MM-dd") : "";
    setEsicForm((prev) => ({ ...prev, [name]: formattedDate }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const parseNumber = (value) =>
      value ? Number(value.toString().replace(/,/g, "")) : 0;

    // ✅ Backend expects a flat object with no nested "receipt" or "auditlog"
    const request = {
      transactionStatus: esicForm.transactionStatus,
      employerCodeNo: esicForm.employerCode, // 🔥 note the correct field name
      employerName: esicForm.employerName,
      challanPeriod: esicForm.challanPeriod,
      challanNumber: esicForm.challanNumber,
      challanCreatedDate: esicForm.challanCreatedDate,
      challanSubmittedDate: esicForm.challanSubmittedDate,
      amountPaid: parseNumber(esicForm.amountPaid),
      transactionNumber: esicForm.transactionNumber,
    };

    const formData = new FormData();
    formData.append(
      "request",
      new Blob([JSON.stringify(request)], { type: "application/json" })
    );

    if (esicForm.file) {
      formData.append("file", esicForm.file);
    }

    try {
      setLoading(true);
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/esic-payment-receipt`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to submit ESIC Payment Receipt data");
      }

      const data = await response.json();
      console.log("✅ API Response:", data);
      setSuccessMessage("ESIC Payment Receipt submitted successfully!");
      setTimeout(() => setSuccessMessage(""), 4000);
    } catch (error) {
      console.error("❌ Failed to submit data:", error);
    } finally {
      setLoading(false);
    }
  };



  const handleClear = () => {
    setEsicForm({
      transactionStatus: "",
      employerCode: "",
      employerName: "",
      challanPeriod: "",
      challanNumber: "",
      challanCreatedDate: "",
      challanSubmittedDate: "",
      amountPaid: "",
      transactionNumber: "",
    });
  };

  const handleCancel = () => {
    Navigate("/dashboard");
  };

  const handleDialogClose = () => {
    setShowDialog(false);
    handleClear();
  };



  const handleFileChange = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      // Example: limit file size to 5 MB (optional)
      const MAX_SIZE = 5 * 1024 * 1024; // 5MB

      if (file.size > MAX_SIZE) {
        setFileErrors((prev) => ({
          ...prev,
          [fieldName]: 'File size must be less than 5 MB',
        }));
        return;
      }

      // Optional: restrict allowed file types
      const allowedTypes = [
        'application/pdf',
        'image/jpeg',
        'image/png',
        'application/vnd.ms-excel',
      ];
      if (!allowedTypes.includes(file.type)) {
        setFileErrors((prev) => ({
          ...prev,
          [fieldName]: 'Only PDF, Excel, JPG, or PNG files are allowed',
        }));
        return;
      }

      // Clear any old errors
      setFileErrors((prev) => ({
        ...prev,
        [fieldName]: '',
      }));

      // ✅ Save the actual File object in state
      setEsicForm((prev) => ({
        ...prev,
        file: file, // <-- important: store the real file, not just metadata
      }));

      // Optional global cache (if needed elsewhere)
      if (!window._uploadedFiles) window._uploadedFiles = {};
      window._uploadedFiles[fieldName] = file;


    }
  };
  return (
    <React.Fragment>
      <div className="esicForm-container">
        <div className="esicForm-box">
          <h2 className="esicForm-heading">ESIC Monthly Contribution</h2>

          <form onSubmit={handleSubmit}>
            {/* Transaction Status */}
            <div className="esicForm-maincontainer">
              <div className="esicForm-container-part">
                <div className="esicForm-floating-label-container-1">
                  <input
                    type="text"
                    name="transactionStatus"
                    value={esicForm.transactionStatus}
                    onChange={handleChange}
                    placeholder=" "
                    required
                  />
                  <label>
                    <span className="required">*</span>Transaction Status
                  </label>
                </div>
              </div>
            </div>

            {/* Employer Code */}
            <div className="esicForm-maincontainer">
              <div className="esicForm-container-part">
                <div className="esicForm-floating-label-container-1">
                  <input
                    type="text"
                    name="employerCode"
                    value={esicForm.employerCode}
                    onChange={handleChange}
                    placeholder=" "
                    required
                  />
                  <label>
                    <span className="required">*</span>Employer Code No
                  </label>
                </div>
              </div>
            </div>

            {/* Employer Name */}
            <div className="esicForm-maincontainer">
              <div className="esicForm-container-part">
                <div className="esicForm-floating-label-container-1">
                  <input
                    type="text"
                    name="employerName"
                    value={esicForm.employerName}
                    onChange={handleChange}
                    placeholder=" "
                    required
                  />
                  <label>
                    <span className="required">*</span>Employer Name
                  </label>
                </div>
              </div>
            </div>

            {/* Challan Period */}
            <div className="esicForm-maincontainer">
              <div className="esicForm-container-part">
                <div
                  className={`esicForm-floating-label-container-2 ${isFocused.challanPeriod || !!esicForm.challanPeriod ? "float-label" : ""
                    }`}
                >
                  <DatePicker
                    // Convert string back to Date for display
                    selected={
                      esicForm.challanPeriod
                        ? new Date(`${esicForm.challanPeriod.split("-")[1]}-${esicForm.challanPeriod.split("-")[0]}-01`)
                        : null
                    }
                    onChange={(date) => {
                      if (date) {
                        // Store as string "SEP-2025"
                        const formatted = format(date, "MMM-yyyy").toUpperCase();
                        setEsicForm((prev) => ({ ...prev, challanPeriod: formatted }));
                      } else {
                        setEsicForm((prev) => ({ ...prev, challanPeriod: "" }));
                      }
                    }}
                    dateFormat="MMM-yyyy"
                    showMonthYearPicker
                    placeholderText="MMM-yyyy"
                    className="did-floating-input"
                  />
                  <label>
                    <span className="required">*</span>Challan Period
                  </label>
                </div>
              </div>
            </div>


            {/* Challan Number */}
            <div className="esicForm-maincontainer">
              <div className="esicForm-container-part">
                <div className="esicForm-floating-label-container-1">
                  <input
                    type="text"
                    name="challanNumber"
                    value={esicForm.challanNumber}
                    onChange={handleChange}
                    placeholder=" "
                    required
                  />
                  <label>
                    <span className="required">*</span>Challan Number
                  </label>
                </div>
              </div>
            </div>

            {/* Challan Created Date */}
            <div className="esicForm-maincontainer">
              <div className="esicForm-container-part">
                <div className={`esicForm-floating-label-container-2 ${isFocused.challanCreatedDate || !!esicForm.challanCreatedDate ? 'float-label' : ''}`}>
                  <DatePicker
                    selected={
                      esicForm.challanCreatedDate
                        ? new Date(esicForm.challanCreatedDate)
                        : null
                    }
                    onChange={(date) =>
                      handleDateChange("challanCreatedDate", date)
                    }
                    dateFormat="dd-MM-yyyy"
                    placeholderText="dd-MM-yyyy"
                    className="did-floating-input"
                  />
                  <label>
                    <span className="required">*</span>Challan Created Date
                  </label>
                </div>
              </div>
            </div>

            {/* Challan Submitted Date */}
            <div className="esicForm-maincontainer">
              <div className="esicForm-container-part">
                <div className={`esicForm-floating-label-container-2 ${isFocused.challanSubmittedDate || !!esicForm.challanSubmittedDate ? 'float-label' : ''}`}>
                  <DatePicker
                    selected={
                      esicForm.challanSubmittedDate
                        ? new Date(esicForm.challanSubmittedDate)
                        : null
                    }
                    onChange={(date) =>
                      handleDateChange("challanSubmittedDate", date)
                    }
                    dateFormat="dd-MM-yyyy"
                    placeholderText="dd-MM-yyyy"
                    className="did-floating-input"
                  />
                  <label>
                    <span className="required">*</span>Challan Submitted Date
                  </label>
                </div>
              </div>
            </div>

            {/* Amount Paid */}
            <div className="esicForm-maincontainer">
              <div className="esicForm-container-part">
                <div className="esicForm-floating-label-container-1">
                  <input
                    type="text"
                    name="amountPaid"
                    value={esicForm.amountPaid}
                    onChange={handleChange}
                    placeholder=" "
                    required
                  />
                  <label>
                    <span className="required">*</span>Amount Paid (₹)
                  </label>
                </div>
              </div>
            </div>

            {/* Transaction Number */}
            <div className="esicForm-maincontainer">
              <div className="esicForm-container-part">
                <div className="esicForm-floating-label-container-1">
                  <input
                    type="text"
                    name="transactionNumber"
                    value={esicForm.transactionNumber}
                    onChange={handleChange}
                    placeholder=" "
                    required
                  />
                  <label>
                    <span className="required">*</span>Transaction Number
                  </label>
                </div>
              </div>
            </div>
            &nbsp;
            {/* upload file */}
            <div className="esicForm-maincontainer">
              <div className="esicForm-container-part">
                <div className="esicForm-input-label">
                  <label>Upload File</label>
                  <input
                    type="file"
                    name="file"
                    onChange={(e) => handleFileChange(e, 'file')}
                  />
                </div>

              </div>
            </div>
            {/* Buttons */}
            <div className="esicForm-btn-div">
              {/* <button
                type="button"
                className="esicForm-cancel"
                onClick={handleCancel}
              >
                Close
              </button>
              <button
                type="button"
                className="esicForm-clear"
                onClick={handleClear}
              >
                Clear
              </button> */}
              <button type="submit" className="esicForm-btn">
                Save

              </button>
            </div>

            {/* Popups */}
            {showSaveSuccess && (
              <div className="confirm-overlay">
                <div className="success-message-popup">
                  {`${successMessage} Temporary ID: ${savedResponse}`}
                </div>
              </div>
            )}

            {showDialog && (
              <div className="confirm-overlay">
                <div className="success-message-popup">
                  <h3>{`${successMessage} Temporary ID: ${savedResponse}`}</h3>
                  <button
                    onClick={handleDialogClose}
                    className="dialog-ok-btn"
                  >
                    OK
                  </button>
                </div>
              </div>
            )}
          </form>
        </div>
      </div>
    </React.Fragment>
  );
};

export default EsiInsurance;
